import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../actions/AdminListRegisterLiveStream';
import withAuth from '../../../common/WithAuth';
import ListRegisterLiveStream from '../../../pages/Admin/RegisterLiveStreamManagement/RegisterLiveStreamManagement';

const mapStateToProps = (state) => ({
    isLoading: state.adminListRegisterLiveStream.getAllOrder.isFetching
    || state.adminListRegisterLiveStream.getDetailOrder.isFetching
    || state.adminListRegisterLiveStream.updateStatus.isFetching
    || state.adminListRegisterLiveStream.resentMail.isFetching,
    listOrderLivestream: state.adminListRegisterLiveStream.getAllOrder.data?.results,
    detailOrderLivestream: state.adminListRegisterLiveStream.getDetailOrder.data?.live_streams,
    listLiveStream: state.adminListRegisterLiveStream.getAllOrder.data,
    listDetailOrderLivestream: state.adminListRegisterLiveStream.getDetailOrder.data,
    updateStatusSuccess: state.adminListRegisterLiveStream.updateStatus.isSuccess,
    errorsUpdateStatus: state.adminListRegisterLiveStream.updateStatus.errors,
    resentMailSuccess: state.adminListRegisterLiveStream.resentMail.isSuccess,
    errorsResentMail: state.adminListRegisterLiveStream.resentMail.errors,
});

const mapDispatchToProps = (dispatch) => ({
    getAllOrderLivestream: (param) => {
        dispatch(Actions.getAllOrderLivestreamRequested(param));
    },
    clearAllLivestream: () => {
        dispatch(Actions.clearOrderLivestreamData());
    },
    getDetailOrderLivestream: (param) => {
        dispatch(Actions.getDetailOrderLivestreamRequested(param));
    },
    clearDetailLivestream: () => {
        dispatch(Actions.clearDetailOrderLivestreamData());
    },
    updateStatusTransaction: (param) => {
        dispatch(Actions.updateStatusLivestreamRequested(param));
    },
    clearUpdateStatus: () => {
        dispatch(Actions.clearStatusLivestream());
    },
    resentMailOrder: (param) => {
        dispatch(Actions.resentMailLivestreamRequested(param));
    },
    clearResentMail: () => {
        dispatch(Actions.clearMailLivestream());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListRegisterLiveStream);
